const { gql } = require('@apollo/client');

export const CREATE_WEBHOOK = gql`
  mutation createWebhook($webhookItem: WebhookItemInput!) {
    saveWebhookItem(webhookItem: $webhookItem) {
      _id
      uid
      secretKey
      webhooksList {
        id
        name
        events
        status
        url
      }
    }
  }
`;

export const UPDATE_WEBHOOK = gql`
  mutation updateWebhookItem($webhookData: UpdateWebhookItemInput!) {
    updateWebhookItem(webhookData: $webhookData) {
      _id
      uid
      secretKey
      webhooksList {
        id
        name
        events
        status
        url
      }
    }
  }
`;

export const DELETE_WEBHOOK = gql`
  mutation deleteWebhookItem($webhookItemId: String!, $webhookId: String!) {
    deleteWebhookItem(webhookItemId: $webhookItemId, webhookId: $webhookId)
  }
`;

export const RESEND_WEBHOOK = gql`
  mutation ResendWebhookEvents($webhookIds: [String!]!) {
    resendWebhookEvents(webhookIds: $webhookIds)
  }
`;

export const REGENERATE_WEBHOOK_SECRET_KEY = gql`
  mutation RegenerateWebhookSecretKey {
    regenerateWebhookSecretKey
  }
`;
